var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('route-table-list',{attrs:{"default-hidden-columns":['public_scope'],"hidden-columns":['brand', 'region', 'account', 'vpc'],"id":_vm.id,"getParams":_vm.getParams}})}
var staticRenderFns = []

export { render, staticRenderFns }